import { List, Record } from "immutable";

import {
  ContentType as ContentTypeType,
  COURSE_SUBSCRIPTION_TIERS
} from "@seneca/course-service-types";

import ContentOptions from "./options/ContentOptions";

export type ContentId = string;
export type SectionId = string;
type ModuleId = string;

export type ContentType = {
  id?: ContentId;
  parentId?: SectionId;
  tags: List<string>;
  prereqTags: List<string>;
  contentModuleIds: List<ModuleId>;
  options: ContentOptions;
  contentType?: ContentTypeType;
  subscriptionTier?: COURSE_SUBSCRIPTION_TIERS;
};

export type OptionalContentType = Partial<ContentType>;

const defaultContent: ContentType = {
  id: undefined,
  parentId: undefined,
  tags: List(),
  prereqTags: List(),
  contentModuleIds: List(),
  options: new ContentOptions(),
  contentType: ContentTypeType.standard,
  subscriptionTier: COURSE_SUBSCRIPTION_TIERS.free
};

export default class Content extends Record(defaultContent) {}
